"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var categoryFillColors = {
  W: 'fill-gray-300',
  G: 'fill-gray-300',
  R: 'fill-gray-300',
  S: 'fill-black',
  D: 'fill-yellow-500',
  F: 'fill-cyan-300',
  C: 'fill-green-500',
  DEFAULT: 'fill-purple-200'
};
var categoryOutsideColors = {
  W: 'fill-gray-400',
  G: 'fill-gray-400',
  R: 'fill-gray-400',
  S: 'fill-black',
  D: 'fill-yellow-600',
  F: 'fill-cyan-500',
  C: 'fill-green-500',
  DEFAULT: 'fill-purple-200'
};

var drivingIcon = function drivingIcon(iconColor) {
  return /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24.19,14.84a.54.54,0,0,1-.25-.06.5.5,0,0,1-.25-.44V4.92a.48.48,0,0,1,.25-.43.45.45,0,0,1,.25-.07.59.59,0,0,1,.25.07L32.29,9.2a.51.51,0,0,1,.24.43.5.5,0,0,1-.24.43l-7.85,4.71A.47.47,0,0,1,24.19,14.84Z",
    className: iconColor
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24.19,4.92l7.43,4.46.41.25-.41.25-7.43,4.46V4.92m0-1a1.13,1.13,0,0,0-.5.13,1,1,0,0,0-.5.87v9.42a1,1,0,0,0,1,1,1.06,1.06,0,0,0,.51-.14l7.44-4.46.41-.25A1,1,0,0,0,33,9.63a1,1,0,0,0-.48-.86l-.41-.24L24.7,4.07a1,1,0,0,0-.51-.15Z",
    style: {
      fill: '#fff'
    }
  }));
};

var standingIcon = function standingIcon(iconColor) {
  return /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("rect", {
    x: "22.81",
    y: "5.1",
    width: "9.17",
    height: "9.17",
    rx: "0.5",
    className: iconColor
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M31.48,5.6v8.17H23.31V5.6h8.17m0-1H23.31a1,1,0,0,0-1,1v8.17a1,1,0,0,0,1,1h8.17a1,1,0,0,0,1-1V5.6a1,1,0,0,0-1-1Z",
    style: {
      fill: '#fff'
    }
  }));
};

var RailCarTankCoupledCustom = function RailCarTankCoupledCustom(_ref) {
  var category = _ref.category,
      movementType = _ref.movementType,
      isEmpty = _ref.isEmpty,
      damageType = _ref.damageType,
      assetReserved = _ref.assetReserved,
      className = _ref.className;
  var assetCategory = Object.keys(categoryFillColors).some(function (key) {
    return key === category;
  }) ? category : 'DEFAULT';
  var fillColor = isEmpty ? 'fill-white' : categoryFillColors[assetCategory];
  var outsideColor = isEmpty ? categoryOutsideColors[assetCategory] : categoryFillColors[assetCategory];
  var damageColor = null;

  if (assetReserved) {
    damageColor = 'fill-green-500';
  }

  if (damageType === 'blue') {
    damageColor = 'fill-cyan-700';
  }

  if (damageType === 'red') {
    damageColor = 'fill-red-500';
  }

  var movementIcon;

  if (movementType === 'DRIVING') {
    movementIcon = drivingIcon(categoryFillColors[assetCategory]);
  }

  if (movementType === 'STANDING') {
    movementIcon = standingIcon(categoryFillColors[assetCategory]);
  }

  return /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "55.97",
    height: "24",
    viewBox: "0 0 55.97 24",
    className: className
  }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M26.61,17.41h-6a3.25,3.25,0,0,0-.39-.35A8.21,8.21,0,0,0,16.83,1.38H13V.75A.76.76,0,0,0,12.26,0H8A.75.75,0,0,0,7.2.75v.63H0V20.79H6.06a3.91,3.91,0,1,0,7-3h1.58a3.91,3.91,0,1,0,7.08,2.28A4,4,0,0,0,21.55,19h5.09a.76.76,0,0,0,.75-.75v0A.78.78,0,0,0,26.61,17.41Zm-16.71,5a2.35,2.35,0,0,1-.57-4.63h1.15a2.35,2.35,0,0,1-.58,4.63Zm7.92,0a2.35,2.35,0,0,1-.5-4.65l.56-.05a2.35,2.35,0,0,1-.06,4.7Z",
    className: fillColor
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M54.78,1.39h-7.2V.75A.75.75,0,0,0,46.83,0H42.52a.76.76,0,0,0-.75.75v.64H38a8.21,8.21,0,0,0-3.43,15.67,4.25,4.25,0,0,0-.39.35h-6a.78.78,0,0,0-.79.78v0s0,0,0,0a.76.76,0,0,0,.75.75h5.09a4,4,0,0,0-.18,1.11,3.92,3.92,0,0,0,7.83,0,3.81,3.81,0,0,0-.75-2.27h1.58a3.9,3.9,0,1,0,7,3h6.06ZM44.31,17.82h1.15a2.36,2.36,0,1,1-1.15,0Zm-7.4-.08.55.05a2.36,2.36,0,1,1-.55-.05Z",
    className: fillColor
  })), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M26.61,17.41h-6a3.25,3.25,0,0,0-.39-.35A8.21,8.21,0,0,0,16.83,1.38H13V.75A.76.76,0,0,0,12.26,0H8A.75.75,0,0,0,7.2.75v.63H0v1.5H16.83A6.71,6.71,0,0,1,18,16.2l-.22,0a3.85,3.85,0,0,0-1,.13h-6a3.43,3.43,0,0,0-1.94,0H0v4.47H6.06a3.91,3.91,0,1,0,7-3h1.58a3.91,3.91,0,1,0,7.08,2.28A4,4,0,0,0,21.55,19h5.09a.76.76,0,0,0,.75-.75v0A.78.78,0,0,0,26.61,17.41Zm-16.71,5a2.35,2.35,0,0,1-.57-4.63h1.15a2.35,2.35,0,0,1-.58,4.63Zm7.92,0a2.35,2.35,0,0,1-.5-4.65l.56-.05a2.35,2.35,0,0,1-.06,4.7Z",
    className: outsideColor
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M38,2.88H54.78V1.39h-7.2V.75A.75.75,0,0,0,46.83,0H42.52a.76.76,0,0,0-.75.75v.64H38a8.21,8.21,0,0,0-3.43,15.67,4.25,4.25,0,0,0-.39.35h-6a.78.78,0,0,0-.79.78v0s0,0,0,0a.76.76,0,0,0,.75.75h5.09a4,4,0,0,0-.18,1.11,3.92,3.92,0,0,0,7.83,0,3.81,3.81,0,0,0-.75-2.27h1.58a3.9,3.9,0,1,0,7,3h6.06V16.32H45.85a3.43,3.43,0,0,0-1.94,0h-6a3.57,3.57,0,0,0-1-.14l-.22,0A6.71,6.71,0,0,1,38,2.88Zm6.36,14.94h1.15a2.36,2.36,0,1,1-1.15,0Zm-7.4-.08.55.05a2.36,2.36,0,1,1-.55-.05Z",
    className: outsideColor
  })), movementIcon, damageColor !== null && /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M55.43,12.6H42.51a.56.56,0,0,1-.46-.23.44.44,0,0,1,0-.47L48.49.25a.59.59,0,0,1,1,0L55.91,11.9a.44.44,0,0,1,0,.47A.56.56,0,0,1,55.43,12.6Z",
    className: damageColor
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M49,9.2a.51.51,0,0,1-.54-.48V5.32a.54.54,0,0,1,1.08,0v3.4A.51.51,0,0,1,49,9.2Z",
    style: {
      fill: '#fff'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M49,9.69a.51.51,0,0,0-.54.48.54.54,0,0,0,1.08,0A.51.51,0,0,0,49,9.69Z",
    style: {
      fill: '#fff'
    }
  }))));
};

RailCarTankCoupledCustom.propTypes = {
  category: _propTypes["default"].string,
  movementType: _propTypes["default"].string.isRequired,
  isEmpty: _propTypes["default"].bool,
  damageType: _propTypes["default"].string,
  assetReserved: _propTypes["default"].bool,
  className: _propTypes["default"].string
};
RailCarTankCoupledCustom.defaultProps = {
  category: 'DEFAULT',
  isEmpty: false,
  damageType: '',
  assetReserved: false,
  className: ''
};
var _default = RailCarTankCoupledCustom;
exports["default"] = _default;